webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var Config = {
  prismic: {
    api_url: 'https://dovedale-deisgn-studio.prismic.io/api',
    login: 'https://dovedale-deisgn-studio.prismic.io/',
    links: function links(doc) {
      if (doc.type === 'collection') return '/collections/' + doc.uid;
      if (doc.type === 'page') return '/' + doc.uid;
      return '/docs/' + doc.id;
    }
  },
  shopify: {
    accessToken: "88c85d167f70ce38355741c8d4e0d14d",
    domain: "dovedaledesign.myshopify.com",
    appId: "6" },
  bkpt: {
    mobile: 600,
    image360: 720 },
  title: 'Dovedale Design Studio',
  email: 'info@dovedaledesignstudio.com',
  phone: '+44 779 382 2428',
  socialMedia: {
    Twitter: 'https://twitter.com/dovedale2016',
    Instagram: 'https://www.instagram.com/dovedaledesignstudio/',
    Facebook: 'https://www.facebook.com/dovedaledesignstudio/',
    Pinterest: 'https://www.pinterest.com/dovedaledesignstudio/'
  },
  mailchimpID: 'a60f52dceb'
};
module.exports = Config;

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(220)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(147),
  /* template */
  __webpack_require__(386),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(235)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(156),
  /* template */
  __webpack_require__(400),
  /* scopeId */
  "data-v-f8150adc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(222)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(142),
  /* template */
  __webpack_require__(388),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(17);
var getRespImgSrc = function getRespImgSrc(prismicObj) {
  var fieldName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'image';
  var profile = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'collection-portrait';

  var w = window.innerWidth;
  switch (profile) {
    case 'collection-portrait':
      var size = w > 600 ? 'tablet' : 'mobile';
      size = w > 1024 ? 'laptop' : size;
      size = w > 1628 ? 'main' : size;
      return prismicObj.getImageView(fieldName, size).url;
    case 'imageset-mobile':
      size = w > 320 ? 'main' : 'narrow';
      return prismicObj.getImageView(fieldName, size).url;
  }
  return null;
};
module.exports = getRespImgSrc;

/***/ }),
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(231)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(130),
  /* template */
  __webpack_require__(396),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(232)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(132),
  /* template */
  __webpack_require__(397),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 64 */,
/* 65 */
/***/ (function(module, exports) {

var addSuffix = function addSuffix(url, size) {
  size = '_' + Math.floor(size) + 'x';
  url = url.replace(/^(.+)\.([^.]+)$/, '$1' + size + '.$2');
  return url;
};

module.exports = addSuffix;

/***/ }),
/* 66 */
/***/ (function(module, exports) {

function StickyHeaders(els, windowTop, windowHeight, parentClass) {
  windowTop = typeof windowTop === 'undefined' ? window.pageYOffset : windowTop;
  var windowBottom = typeof windowHeight === 'undefined' ? windowTop + window.innerHeight : windowTop + windowHeight;

  Array.prototype.forEach.call(els, function (el) {
    var parent = typeof parentClass === 'undefined' ? el.parentElement : el.closest(parentClass);
    var scrollTop = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;
    var parentTop = parent.getBoundingClientRect().top + scrollTop;
    var parentBottom = parentTop + parent.offsetHeight;

    if (windowBottom > parentBottom) {
      el.setAttribute('data-sticky-header', 'bottom');
    } else if (parentTop <= windowTop && windowBottom <= parentBottom) {
      el.setAttribute('data-sticky-header', 'fixed');
    } else {
      el.removeAttribute('data-sticky-header');
    }
  });
}

module.exports = StickyHeaders;

/***/ }),
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */
/***/ (function(module, exports) {

module.exports = {"name":"prismic.io","description":"JavaScript development kit for prismic.io","license":"Apache-2.0","url":"https://github.com/prismicio/javascript-kit","keywords":["prismic","prismic.io","cms","content","api"],"version":"3.6.1","engines":{"node":">=4.8.1","npm":">=2.15.11"},"devDependencies":{"babel-preset-es2015":"~6.24.0","babelify":"~7.3.0","browserify":"~14.1.0","chai":"~3.5.0","codeclimate-test-reporter":"~0.4.1","es6-promise":"~4.1.0","eslint":"~3.18.0","istanbul":"~0.4.5","jsdoc":"~3.4.3","mocha":"~3.2.0","rimraf":"~2.6.1","uglify-js":"~2.8.16","vinyl-buffer":"~1.0.0","vinyl-source-stream":"~1.1.0"},"repository":{"type":"git","url":"http://github.com/prismicio/javascript-kit.git"},"main":"lib/prismic.js","scripts":{"build":"scripts/browser.js","postbuild":"npm run docs","uglify":"uglifyjs -c -o=dist/prismic.io.min.js dist/prismic.io.js","preuglify":"npm run build","prepublish":"npm run uglify","lint":"eslint lib","test":"istanbul cover _mocha -- -t 3000 test/","posttest":"eslint lib","predocs":"rimraf ./docs","docs":"jsdoc lib/*.js README.md -d docs"}}

/***/ }),
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(233)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(141),
  /* template */
  __webpack_require__(398),
  /* scopeId */
  "data-v-e4618e04",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(217)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(158),
  /* template */
  __webpack_require__(383),
  /* scopeId */
  "data-v-44d05e26",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 119 */,
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_src_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Intro__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Intro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_Intro__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Page__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_Page__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Collections__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Collections___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_Collections__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Collection__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Collection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_Collection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_CollectionItem__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_CollectionItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_CollectionItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Collection_SKUs__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Collection_SKUs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_Collection_SKUs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_NotesPane__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_NotesPane___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_NotesPane__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Purchase__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Purchase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_Purchase__);












__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Intro',
    component: __WEBPACK_IMPORTED_MODULE_3_components_Intro___default.a,
    meta: { hideFooter: true },
    children: [{
      path: 'notes',
      name: 'Notes',
      component: __WEBPACK_IMPORTED_MODULE_9_components_NotesPane___default.a,
      meta: { hideFooter: true }
    }]
  }, {
    path: '/collections',
    name: 'Collections',
    component: __WEBPACK_IMPORTED_MODULE_5_components_Collections___default.a
  }, {
    path: '/collections/:slug/items',
    name: 'Collection Items',
    component: __WEBPACK_IMPORTED_MODULE_8_components_Collection_SKUs___default.a,
    props: true,
    meta: {
      updateMetaTitle: true
    },
    children: [{
      path: ':id',
      name: 'Collection Items – Item Overlay',
      component: __WEBPACK_IMPORTED_MODULE_7_components_CollectionItem___default.a,
      props: true,
      meta: {
        isOverlay: true
      }
    }]
  }, {
    path: '/collections/:slug',
    name: 'Collection',
    component: __WEBPACK_IMPORTED_MODULE_6_components_Collection___default.a,
    props: true,
    children: [{
      path: 'item/:id',
      name: 'Collection - Item Overlay',
      component: __WEBPACK_IMPORTED_MODULE_7_components_CollectionItem___default.a,
      props: true,
      meta: {
        isOverlay: true,
        hide360Images: true
      }
    }]
  }, {
    path: '/purchase',
    name: 'Purchase',
    component: __WEBPACK_IMPORTED_MODULE_10_components_Purchase___default.a,
    props: true
  }, {
    path: '/login',
    redirect: function redirect(to) {
      window.location.replace(__WEBPACK_IMPORTED_MODULE_2_src_config___default.a.prismic.login);
      return false;
    }
  }, {
    path: '/:slug',
    name: 'Page',
    component: __WEBPACK_IMPORTED_MODULE_4_components_Page___default.a,
    props: true
  }, {
    path: '*',
    name: '404',
    component: __WEBPACK_IMPORTED_MODULE_4_components_Page___default.a,
    props: true
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      };
    }
  }
}));

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_find__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shopify_buy__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shopify_buy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_shopify_buy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prismic_io__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prismic_io___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prismic_io__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_src_config__);








__WEBPACK_IMPORTED_MODULE_1_vue___default.a.shopClient = __WEBPACK_IMPORTED_MODULE_4_shopify_buy___default.a.buildClient({
  domain: "dovedaledesign.myshopify.com",
  storefrontAccessToken: "88c85d167f70ce38355741c8d4e0d14d"
});
var shop = __WEBPACK_IMPORTED_MODULE_1_vue___default.a.shopClient;

__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* default */].Store({
  state: {
    site: null,
    collections: [],
    checkout: { lineItems: [] },
    shopCollections: []
  },
  mutations: {
    setInitialDocs: function setInitialDocs(state, docs) {
      for (var i = 0; i < docs.length; i++) {
        if (docs[i].type === 'site') state.site = docs[i];else if (docs[i].type === 'collection') state.collections.push(docs[i]);
      }
    },
    setCheckout: function setCheckout(state, checkout) {
      state.checkout = checkout;
    },
    addShopCollection: function addShopCollection(state, collection) {
      state.shopCollections.push(collection);
    }
  },
  actions: {
    getInitialDocs: function getInitialDocs(_ref) {
      var commit = _ref.commit,
          state = _ref.state;

      __WEBPACK_IMPORTED_MODULE_5_prismic_io___default.a.api(__WEBPACK_IMPORTED_MODULE_6_src_config___default.a.prismic.api_url).then(function (api) {
        return api.query(__WEBPACK_IMPORTED_MODULE_5_prismic_io___default.a.Predicates.any('document.type', ['site', 'collection']), { pageSize: 100, orderings: '[my.collection.number]' });
      }).then(function (resp) {
        return commit('setInitialDocs', resp.results);
      }).catch(function (err) {
        return console.error('Error: Get Initial Docs failed', err);
      });
    },
    getShopCollection: function getShopCollection(_ref2, id) {
      var commit = _ref2.commit,
          state = _ref2.state;

      if (!id) return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error('No Collection ID specified'));

      id = __WEBPACK_IMPORTED_MODULE_1_vue___default.a.getShopifyID(id, 'Collection');

      var stored = __WEBPACK_IMPORTED_MODULE_3_lodash_find___default()(state.shopCollections, ['id', id]);
      if (stored) return false;

      shop.collection.fetchWithProducts(id).then(function (collection) {
        commit('addShopCollection', collection);
      });
    },
    createCheckout: function createCheckout(_ref3) {
      var dispatch = _ref3.dispatch,
          commit = _ref3.commit,
          state = _ref3.state;

      var savedId = localStorage.getItem('checkoutId');
      if (savedId) {
        return shop.checkout.fetch(savedId).then(function (checkout) {
          if (!checkout || checkout.completedAt) {
            console.log('Cart already completed. Creating new...');
            localStorage.removeItem('checkoutId');
            dispatch('createCheckout');
          }
          console.log('existing checkout > ', checkout);
          commit('setCheckout', checkout);
        }, function (err) {
          console.error(err);
          console.error('Fetch checkout by ID failed. Creating new...');
          localStorage.removeItem('checkoutId');
          dispatch('createCheckout');
        });
      }

      return shop.checkout.create().then(function (checkout) {
        localStorage.setItem('checkoutId', checkout.id);
        commit('setCheckout', checkout);
        console.log('New Cart created.');
      }, function (err) {
        return console.error('Create new checkout failed.', err);
      });
    },
    addToCart: function addToCart(_ref4, variantId) {
      var commit = _ref4.commit,
          state = _ref4.state;

      if (!state.checkout.id) return false;
      var lineItemsToAdd = [{ variantId: variantId, quantity: 1 }];
      shop.checkout.addLineItems(state.checkout.id, lineItemsToAdd).then(function (checkout) {
        commit('setCheckout', checkout);
      });
    },
    updateCartItem: function updateCartItem(_ref5, data) {
      var commit = _ref5.commit,
          state = _ref5.state;

      if (!state.checkout.id) return false;
      var error = !data.id || typeof data.quantity === 'undefined';
      if (error) return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error('Empty data.id or data.quantity'));
      var lineItemsToUpdate = [{ id: data.id, quantity: data.quantity }];
      shop.checkout.updateLineItems(state.checkout.id, lineItemsToUpdate).then(function (checkout) {
        commit('setCheckout', checkout);
      });
    },
    removeCartItems: function removeCartItems(_ref6, lineItemIds) {
      var commit = _ref6.commit,
          state = _ref6.state;

      if (!lineItemIds) {
        lineItemIds = [];
        for (var i = 0; i < state.checkout.lineItems.length; i++) {
          lineItemIds.push(state.checkout.lineItems[i].id);
        }
      }

      shop.checkout.removeLineItems(state.checkout.id, lineItemIds).then(function (checkout) {
        commit('setCheckout', checkout);
      });
    }
  }
}));

/***/ }),
/* 122 */,
/* 123 */,
/* 124 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(205)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(127),
  /* template */
  __webpack_require__(371),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */,
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_meta__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_facebook_pixel__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_facebook_pixel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_facebook_pixel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_gtag__ = __webpack_require__(123);










__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_vue_meta__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_vue_facebook_pixel___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_vue_gtag__["a" /* default */], {
  config: { id: 'G-NNNLGN1BMP' }
}, __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.getShopifyID = function (id) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Product';

  if (!id) return console.error('No ID specified');

  return 'gid://shopify/' + type + '/' + id;
};

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.is = function () {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (name === 'mobile') return window.innerWidth <= __WEBPACK_IMPORTED_MODULE_4__config___default.a.bkpt.mobile;
  return false;
};

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.updateMeta = {
  _siteTitle: __WEBPACK_IMPORTED_MODULE_4__config___default.a.title,
  _siteDescription: 'Contemporary Products, Traditional Craftsmanship, Designed and Conceived in London',
  setTitle: function setTitle(pageTitle) {
    var title = pageTitle ? pageTitle + ' | ' + this._siteTitle : this._siteTitle;
    document.title = title;
  },
  setDescription: function setDescription(description) {
    description = !description ? this._siteDescription : description;
    var meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute('content', description);
  }
};

new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_src_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Nav__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Nav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Screensaver__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Screensaver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Screensaver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_SubscribePopUp__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_SubscribePopUp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_SubscribePopUp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_throttle__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_throttle__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_4__components_Nav___default.a,
    Screensaver: __WEBPACK_IMPORTED_MODULE_5__components_Screensaver___default.a,
    SubscribePopUp: __WEBPACK_IMPORTED_MODULE_6__components_SubscribePopUp___default.a
  },
  data: function data() {
    return {
      pageTransition: 'fade',
      theme: 'light',
      navVisible: true,
      siteIntro: true,
      siteIntroDuration: 3000,
      siteReady: false,
      siteIntroVideoPlaying: false,
      sleepMode: {
        enabled: "production" !== 'development',
        active: false,
        timer:  false ? 5000 : 40000,
        timeout: null
      },
      resizeTimeout: null,
      window: {
        height: 0,
        width: 0,
        bkpt: __WEBPACK_IMPORTED_MODULE_3_src_config___default.a.bkpt
      }
    };
  },
  metaInfo: function metaInfo() {
    return {
      link: [{ rel: 'canonical', href: 'https://www.dovedaledesignstudio.com' + this.$route.path }],
      meta: [{
        name: 'author',
        content: 'Dovedale Design Studio'
      }, {
        property: 'og:site_name',
        content: 'Dovedale Design Studio'
      }, { property: 'og:type', content: 'website' }, {
        property: 'og:url',
        content: 'https://www.dovedaledesignstudio.com' + this.$route.path
      }, { name: 'twitter:card', content: 'summary' }, { name: 'twitter:site', content: 'https://www.dovedaledesignstudio.com' + this.$route.path }, {
        property: 'og:type',
        content: 'business.business'
      }, {
        property: 'business:contact_data:street_address',
        content: '465 Battersea Park Rd'
      }, {
        property: 'business:contact_data:locality',
        content: 'London'
      }, {
        property: 'business:contact_data:region',
        content: 'London'
      }, {
        property: 'business:contact_data:postal_code',
        content: ' SW11 4LR'
      }, {
        property: 'business:contact_data:country_name',
        content: 'UK'
      }, {
        property: 'place:location:latitude',
        content: '51.4722296'
      }, {
        property: 'place:location:longitude',
        content: '-0.1655434'
      }],
      script: [{
        type: 'application/ld+json',
        json: {
          '@context': 'http://schema.org',
          '@type': 'LocalBusiness',
          'name': 'Dovedale Design Studio',
          'image': this.site ? this.site.data['site.share_image'].value.main.url : '',
          'address': {
            '@type': 'PostalAddress',
            'streetAddress': '465 Battersea Park Rd',
            'addressLocality': 'London',
            'addressRegion': 'London',
            'postalCode': 'SW11 4LR',
            'addressCountry': 'UK'
          },
          'telephone': '+44 779 382 2428',
          'url': 'https://dovedaledesignstudio.com'
        }
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(['site', 'collections']), {
    isMobile: function isMobile() {
      return this.window.width <= this.window.bkpt.mobile;
    },
    navTransition: function navTransition() {
      return this.siteIntro ? 'longfade' : 'fadeinplace';
    }
  }),
  watch: {
    '$route': function $route(to, from) {
      this.$route.meta.firstPage = false;

      if (to.name !== 'Page') this.theme = 'light';

      var transition = 'fade';
      var toDepth = to.path.split('/');
      var fromDepth = from.path.split('/');

      if (fromDepth.length !== toDepth.length && to.name !== 'Page' && from.name !== 'Page') {
        transition = toDepth.length < fromDepth.length ? 'slide-right' : 'slide-left';
      }

      var isOverlay = to.matched.some(function (record) {
        return record.meta.isOverlay;
      });
      if (transition !== 'slide-right' && !isOverlay && !to.hash) {
        var delay = transition.indexOf('slide') > -1 ? 700 : 400;
        setTimeout(function () {
          window.scrollTo(0, 0);
        }, delay);
      }
      this.pageTransition = transition;

      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_1_vue___default.a.analytics.fbq.event('PageView');
      }, 200);
    },
    site: function site() {
      var descrip = this.site.getText('site.meta_description');
      if (descrip) __WEBPACK_IMPORTED_MODULE_1_vue___default.a.updateMeta._siteDescription = descrip;
      console.log('site', this.site);
    }
  },
  methods: {
    changeTheme: function changeTheme() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'light';

      this.theme = value;
    },
    onResize: function onResize() {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(this.saveWindowData, 100);
    },
    saveWindowData: function saveWindowData() {
      this.window.height = window.innerHeight;
      this.window.width = window.innerWidth;
    },
    endIntro: function endIntro() {
      this.siteIntroVideoPlaying = true;
      if (this.siteReady) this.siteIntro = false;
    },
    siteIntroInit: function siteIntroInit() {
      var _this = this;

      this.siteIntro = window.innerWidth > this.window.bkpt.mobile && this.$route.name === 'Intro' && this.$route.meta.firstPage;
      if (!this.siteIntro) {
        this.siteReady = true;return;
      }
      setTimeout(function () {
        _this.siteReady = true;
        if (_this.siteIntroVideoPlaying) _this.siteIntro = false;
      }, this.siteIntroDuration);
    },
    resetSleepTimer: __WEBPACK_IMPORTED_MODULE_7_lodash_throttle___default()(function () {
      var _this2 = this;

      clearTimeout(this.sleepMode.timeout);

      if (this.sleepMode.active) {
        this.sleepMode.active = false;
      }

      if (this.sleepMode.enabled) {
        if (!this.mobileLayout) {
          this.sleepMode.timeout = setTimeout(function () {
            _this2.sleepMode.active = true;
          }, this.sleepMode.timer);
        }
      }
    }, 1500)
  },
  beforeCreate: function beforeCreate() {
    this.$store.dispatch('getInitialDocs');
  },
  created: function created() {
    this.$route.meta.firstPage = true;
    this.saveWindowData();
    this.siteIntroInit();
    window.addEventListener('resize', this.onResize);
    console.log('Sleep Enabled: ' + this.sleepMode.enabled);
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1_vue___default.a.analytics.fbq.init('2293469067361860');
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.onResize);
  }
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Button--Boxed'
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Collection_Story__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Collection_Story___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Collection_Story__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Collection_SKUs__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Collection_SKUs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Collection_SKUs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_SubscribeForm__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_SubscribeForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_src_components_SubscribeForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_Footer__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_src_components_Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_LogoMarque__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_LogoMarque___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_src_components_LogoMarque__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'collection',
  props: ['window', 'mobile', 'slug', 'site', 'collections'],
  data: function data() {
    return {
      loadStory: false
    };
  },
  metaInfo: function metaInfo() {
    var title = this.collection ? this.collection.getText('collection.title') : 'Dovedale Design Studio';
    var description = this.collection ? this.collection.getText('collection.meta_description') : '';
    var metaKeywords = this.collection ? this.collection.getText('collection.meta_keywords') : '';
    var shareImage = this.collection && this.collection.data['collection.share_image'] && this.collection.data['collection.share_image'].value.main.url ? this.collection.data['collection.share_image'].value.main.url : '';

    return {
      meta: [{ name: 'description', content: description }, { name: 'keywords', content: metaKeywords }, { property: 'og:title', content: title }, { property: 'og:description', content: description }, { property: 'og:image', content: shareImage }, { name: 'twitter:title', content: title }, { name: 'twitter:description', content: description }, { name: 'twitter:image:src', content: shareImage }, { itemprop: 'name', content: title }, { itemprop: 'description', content: description }, { itemprop: 'image', content: shareImage }]
    };
  },

  components: {
    Story: __WEBPACK_IMPORTED_MODULE_1__Collection_Story___default.a,
    Items: __WEBPACK_IMPORTED_MODULE_2__Collection_SKUs___default.a,
    SubscribeForm: __WEBPACK_IMPORTED_MODULE_3_src_components_SubscribeForm___default.a,
    Appfooter: __WEBPACK_IMPORTED_MODULE_4_src_components_Footer___default.a,
    LogoMarque: __WEBPACK_IMPORTED_MODULE_5_src_components_LogoMarque___default.a
  },
  computed: {
    isBespoke: function isBespoke() {
      if (this.collection.slug === 'bespoke-service') {
        return true;
      }
    },
    collectionIndex: function collectionIndex() {
      var _this = this;

      if (this.collections) {
        var matches = this.collections.map(function (collection, index) {
          if (collection.uid === _this.slug) {
            return index;
          }
        }).filter(isFinite);
        return matches[0];
      }
      return null;
    },
    collection: function collection() {
      return this.collections ? this.collections[this.collectionIndex] : null;
    },
    number: function number() {
      return this.collection.getNumber('collection.number');
    },
    title: function title() {
      return this.collection.getText('collection.title');
    },
    featuredImg: function featuredImg() {
      var img = this.collection.getImage('collection.index-image--mobile').url;
      return img || false;
    },
    prevCollection: function prevCollection() {
      return this.getSibling(-1);
    },
    nextCollection: function nextCollection() {
      return this.getSibling();
    },
    shareBtns: function shareBtns() {
      var channels = [{
        label: 'Twitter',
        url: 'https://twitter.com/intent/tweet?url=' + document.location.href
      }, {
        label: 'Email',
        url: 'mailto:?&subject=' + encodeURIComponent(document.title) + '&body=' + document.location.href
      }, {
        label: 'Facebook',
        url: 'https://www.facebook.com/sharer.php?u=' + document.location.href
      }];

      if (this.featuredImg) {
        channels.push({
          label: 'Pinterest',
          url: 'https://pinterest.com/pin/create/bookmarklet/?media=' + this.featuredImg + '&url=' + document.location.href + '&description=' + document.location.title
        });
      }
      return channels;
    }
  },
  watch: {
    collection: function collection() {
      this.updateMeta();
    },
    '$route': function $route(to, from) {
      if (to.name === 'Collection') this.updateMeta();
      this.setLoadStory();
    }
  },
  methods: {
    updateMeta: function updateMeta() {
      if (!this.collection) return false;
      var title = this.collection.getText('collection.title');
      __WEBPACK_IMPORTED_MODULE_0_vue___default.a.updateMeta.setTitle(title);
      var descrip = this.collection.getText('collection.meta_description');
      if (descrip) __WEBPACK_IMPORTED_MODULE_0_vue___default.a.updateMeta.setDescription(descrip);
    },
    getSibling: function getSibling() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      var bro = this.collections[this.collectionIndex + direction];
      if (bro) {
        if (bro.data['collection.hide-on-index']) {
          return bro.getBoolean('collection.hide-on-index') ? null : bro;
        }
        return bro;
      }
      return null;
    },
    setLoadStory: function setLoadStory() {
      this.loadStory = this.$route.name === 'Collection';
    }
  },
  created: function created() {
    this.updateMeta();
    this.setLoadStory();
  }
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_src_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_InteractiveImage__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_InteractiveImage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_InteractiveImage__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CollectionImage',
  props: {
    image: {
      type: Object,
      default: {
        type: null,
        src: null,
        caption: null,
        alt: '',
        table: null,
        grayscale: false
      }
    }
  },
  components: {
    InteractiveImage: __WEBPACK_IMPORTED_MODULE_1_components_InteractiveImage___default.a
  },
  computed: {
    grayscale: function grayscale() {
      return this.image.grayscale === 'undefined' ? false : this.image.grayscale;
    },
    hasTable: function hasTable() {
      return this.image.table && (this.image.table.header || this.image.table.text) && this.image.type !== 'image-360';
    }
  },
  methods: {
    setCaption: function setCaption(image) {
      var caption = image.caption;
      if (image.type === 'image-360' && window.innerWidth > __WEBPACK_IMPORTED_MODULE_0_src_config___default.a.bkpt.image360) {
        var after = ' (Rollover to view)';
        caption = caption.indexOf('</p>') ? caption.replace('</p>', after + '</p>') : caption + after;
      }
      return caption;
    }
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LogoMarque__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LogoMarque___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__LogoMarque__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Slideshow__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Slideshow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_Slideshow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_find__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_find__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CollectionItem',
  props: ['id', 'products', 'preloadImg', 'collectionTitle'],
  components: {
    Logo: __WEBPACK_IMPORTED_MODULE_1__LogoMarque___default.a,
    Slideshow: __WEBPACK_IMPORTED_MODULE_2_components_Slideshow___default.a
  },
  data: function data() {
    return {
      slideshowVisible: false
    };
  },

  computed: {
    cart: function cart() {
      return this.$store.state.checkout;
    },
    product: function product() {
      return __WEBPACK_IMPORTED_MODULE_3_lodash_find___default()(this.products, ['handle', this.id]);
    },
    priceHTML: function priceHTML() {
      var price = this.product.variants[0].price.amount;

      price = price.toString().replace(/\.?0+$/, '');
      var currency = this.product.variants[0].price.currencyCode;
      return '<div class="price"><label>Price</label>' + price + ' ' + currency + '</div><div></div>';
    },
    cartItem: function cartItem() {
      return __WEBPACK_IMPORTED_MODULE_3_lodash_find___default()(this.cart.lineItems, ['title', this.product.title]);
    },
    cartTotalCount: function cartTotalCount() {
      if (!this.cart || !this.cart.lineItems) return 0;
      var total = 0;
      for (var i = 0; i < this.cart.lineItems.length; i++) {
        total += this.cart.lineItems[i].quantity;
      }
      return total;
    }
  },
  watch: {
    product: function product() {
      this.updateMeta();
    }
  },
  methods: {
    close: function close() {
      if (this.$route.meta.firstPage) {
        this.$router.push({ name: 'Collection', params: { slug: this.$route.params.slug } });
      } else {
        this.$router.back();
      }
    },
    addToCart: function addToCart(variant) {
      if (!this.cartItem) return this.$store.dispatch('addToCart', this.product.variants[0].id);
      return this.updateCartItem(1);
    },
    updateCartItem: function updateCartItem(difference) {
      if (!this.cartItem) return;
      var qty = this.cartItem.quantity + difference;
      this.$store.dispatch('updateCartItem', { id: this.cartItem.id, quantity: qty });
    },
    clear: function clear() {
      var items = this.cartItem ? [this.cartItem.id] : null;
      return this.$store.dispatch('removeCartItems', items);
    },
    updateMeta: function updateMeta() {
      var title = this.product && this.product.title;
      if (!title) return;
      title = this.collectionTitle ? title + ' – ' + this.collectionTitle : title;
      __WEBPACK_IMPORTED_MODULE_0_vue___default.a.updateMeta.setTitle(title);
    }
  },
  mounted: function mounted() {
    this.$store.dispatch('createCheckout');
  }
});

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_src_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Collection_SKUs_Item__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Collection_SKUs_Item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_src_components_Collection_SKUs_Item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_find__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_find__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CollectionSKUs',
  components: { skuItem: __WEBPACK_IMPORTED_MODULE_2_src_components_Collection_SKUs_Item___default.a },
  props: {
    slug: String,
    collections: Array,
    itemViewName: {
      type: String,
      default: 'Collection Items – Item Overlay'
    },
    options: {
      type: Object,
      default: function _default() {
        return { customOrders: true, isPurchase: false };
      }
    }
  },
  data: function data() {
    return {
      cart: null,
      readMore: false
    };
  },
  metaInfo: function metaInfo() {
    var title = this.collection ? this.collection.getText('collection.title') : 'Dovedale Design Studio';
    var description = this.collection ? this.collection.getText('collection.meta_description') : '';
    var metaKeywords = this.collection ? this.collection.getText('collection.meta_keywords') : '';
    var shareImage = this.collection && this.collection.data['collection.share_image'] && this.collection.data['collection.share_image'].value.main.url ? this.collection.data['collection.share_image'].value.main.url : '';

    return {
      meta: [{ name: 'description', content: description }, { name: 'keywords', content: metaKeywords }, { property: 'og:title', content: title }, { property: 'og:description', content: description }, { property: 'og:image', content: shareImage }, { name: 'twitter:title', content: title }, { name: 'twitter:description', content: description }, { name: 'twitter:image:src', content: shareImage }, { itemprop: 'name', content: title }, { itemprop: 'description', content: description }, { itemprop: 'image', content: shareImage }]
    };
  },


  computed: {
    collection: function collection() {
      return __WEBPACK_IMPORTED_MODULE_3_lodash_find___default()(this.collections, ['uid', this.slug]);
    },
    shopCollectionId: function shopCollectionId() {
      return this.collection && this.collection.getNumber('collection.shopify-collection-id');
    },
    products: function products() {
      if (!this.shopCollectionId) return [];

      var shopCollection = __WEBPACK_IMPORTED_MODULE_3_lodash_find___default()(this.$store.state.shopCollections, ['id', __WEBPACK_IMPORTED_MODULE_0_vue___default.a.getShopifyID(this.shopCollectionId, 'Collection')]) || {};

      return shopCollection.products || [];
    },
    shortTitle: function shortTitle() {
      return this.collection ? this.collection.getText('collection.title') : '';
    },
    title: function title() {
      return this.collection.getText('collection.items--header');
    },
    text: function text() {
      return this.collection.getStructuredText('collection.items--text').asHtml(__WEBPACK_IMPORTED_MODULE_1_src_config___default.a.prismic.links);
    },
    email: function email() {
      return this.collection.getText('collection.items--enquire-email');
    }
  },
  watch: {
    '$route': function $route(to, from) {
      this.getCart();
    },
    collection: function collection() {
      this.updateMeta();
    },
    shopCollectionId: function shopCollectionId() {
      this.getProducts();
    }
  },
  methods: {
    getCart: function getCart() {},
    getProducts: function getProducts() {
      var id = this.shopCollectionId;
      if (id) this.$store.dispatch('getShopCollection', id);
    },
    updateMeta: function updateMeta() {
      if (!this.collection) return false;
      if (this.$route.meta.updateMetaTitle) {
        var title = 'Purchase ' + this.collection.getText('collection.title');
        __WEBPACK_IMPORTED_MODULE_0_vue___default.a.updateMeta.setTitle(title);
      }

      var descrip = this.collection.getText('collection.meta_description');
      if (descrip) __WEBPACK_IMPORTED_MODULE_0_vue___default.a.updateMeta.setDescription(descrip);
    }
  },
  created: function created() {
    this.getProducts();

    this.getCart();
    this.updateMeta();
  }
});

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_src_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assets_js_resizeShopifyImgUrl__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assets_js_resizeShopifyImgUrl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assets_js_resizeShopifyImgUrl__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Collection__SKUs__Item',
  props: ['product', 'viewName', 'isPurchase', 'collectionSlug'],
  data: function data() {
    return {
      imgLoaded: false
    };
  },

  methods: {
    shopifyImg: function shopifyImg(url) {
      var size = window.innerWidth > __WEBPACK_IMPORTED_MODULE_0_src_config___default.a.bkpt.mobile ? window.innerWidth / 3 * 1.6 : window.innerWidth * 1.6;
      return __WEBPACK_IMPORTED_MODULE_1_assets_js_resizeShopifyImgUrl___default()(url, size);
    },
    routerTo: function routerTo() {
      if (this.isPurchase) {
        return '/collections/' + this.collectionSlug + '/items/' + this.product.handle;
      } else {
        return { name: this.viewName, params: { id: this.product.handle } };
      }
    }
  }
});

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_src_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Collection_Story_CoverPhoto__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Collection_Story_CoverPhoto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_Collection_Story_CoverPhoto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Collection_Story_Text__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Collection_Story_Text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_Collection_Story_Text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Collection_Story_Spread__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Collection_Story_Spread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_Collection_Story_Spread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Collection_Story_Diptych__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Collection_Story_Diptych___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_Collection_Story_Diptych__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Collection_Story_LandscapeImage__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Collection_Story_LandscapeImage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_Collection_Story_LandscapeImage__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CollectionStory',
  props: ['window', 'mobile', 'sections'],
  components: {
    CoverPhoto: __WEBPACK_IMPORTED_MODULE_1_components_Collection_Story_CoverPhoto___default.a,
    TextBlock: __WEBPACK_IMPORTED_MODULE_2_components_Collection_Story_Text___default.a,
    Spread: __WEBPACK_IMPORTED_MODULE_3_components_Collection_Story_Spread___default.a,
    Diptych: __WEBPACK_IMPORTED_MODULE_4_components_Collection_Story_Diptych___default.a,
    LandscapeImage: __WEBPACK_IMPORTED_MODULE_5_components_Collection_Story_LandscapeImage___default.a
  },
  methods: {
    showBlock: function showBlock(block) {
      return block.data['hide-on-mobile'] ? !(this.mobile && block.getBoolean('hide-on-mobile')) : true;
    },
    setBlock: function setBlock(key, layout) {
      var block = {
        layout: 'unknown',
        variant: null
      };
      switch (layout) {
        case 'Text':
          block.layout = 'text-block';
          break;
        case 'Quote':
          block.layout = 'text-block';
          block.variant = 'quote';
          break;
        case 'Spread – Image | Image':
          block.layout = 'spread';
          break;
        case 'Spread – Images | Text':
          block.layout = 'spread';
          block.variant = 'topic - reverse';
          break;
        case 'Spread – Text | Images':
          block.layout = 'spread';
          block.variant = 'topic';
          break;
        case 'Diptych – Black':
          block.layout = 'diptych';
          break;
        case 'Diptych – White':
          block.layout = 'diptych';
          block.variant = 'white';
          break;
        case 'Landscape Image':
          block.layout = 'landscape-image';
          break;
        case 'Bleed Image':
          block.layout = 'cover-photo';
          break;
      }
      return block[key];
    },
    html: function html(block, APIid) {
      return block.getStructuredText(APIid) ? block.getStructuredText(APIid).asHtml(__WEBPACK_IMPORTED_MODULE_0_src_config___default.a.prismic) : null;
    },
    getLandscapeImageUrl: function getLandscapeImageUrl(block) {
      var w = window.innerWidth;
      var size = w > 600 ? 'laptop' : 'mobile';
      size = w > 800 ? 'desktop' : size;
      size = w > 1024 ? 'main' : size;
      var imgObj = block.getImageView('image', size);
      return imgObj ? imgObj.url : null;
    }
  }
});

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CoverPhoto',
  props: ['imageUrl', 'imageAlt', 'text'],
  data: function data() {
    return {};
  }
});

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_src_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prismic_io__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prismic_io___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prismic_io__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_CollectionImage__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_CollectionImage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_CollectionImage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assets_js_getRespImgSrc__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assets_js_getRespImgSrc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_assets_js_getRespImgSrc__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Diptych',
  props: ['variant', 'imagesetId'],
  components: {
    CollectionImage: __WEBPACK_IMPORTED_MODULE_2_components_CollectionImage___default.a
  },
  data: function data() {
    return {
      images: null
    };
  },

  methods: {
    buildImgObj: function buildImgObj(image) {
      return {
        type: null,
        src: __WEBPACK_IMPORTED_MODULE_3_assets_js_getRespImgSrc___default()(image, 'image'),
        caption: image.getStructuredText('caption').asHtml(__WEBPACK_IMPORTED_MODULE_0_src_config___default.a.prismic.links),
        alt: image.data['caption'] ? image.getText('caption') : '',
        table: {
          header: image.getText('table--header'),
          text: image.getStructuredText('table--text') ? image.getStructuredText('table--text').asHtml(__WEBPACK_IMPORTED_MODULE_0_src_config___default.a.prismic.links) : null
        }
      };
    },
    getImageset: function getImageset() {
      var _this = this;

      if (this.imagesetId) {
        __WEBPACK_IMPORTED_MODULE_1_prismic_io___default.a.api(__WEBPACK_IMPORTED_MODULE_0_src_config___default.a.prismic.api_url).then(function (api) {
          return api.getByID(_this.imagesetId);
        }).then(function (response) {
          _this.images = response.getGroup('imageset.images').value;
        }, function (err) {
          console.log('Error getting Imageset: ', err);
        });
      }
    }
  },
  created: function created() {
    this.getImageset();
  }
});

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_CollectionImage__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_CollectionImage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_CollectionImage__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LandscapeImage',
  props: ['imageUrl', 'imageAlt', 'text', 'imageTableHeader', 'imageTableText'],
  components: {
    CollectionImage: __WEBPACK_IMPORTED_MODULE_0_components_CollectionImage___default.a
  },
  data: function data() {
    return {};
  },

  computed: {
    image: function image() {
      return {
        type: null,
        src: this.imageUrl,
        caption: this.text,
        alt: this.imageAlt,
        table: {
          header: this.imageTableHeader,
          text: this.imageTableText
        }
      };
    }
  }
});

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_src_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_CollectionImage__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_CollectionImage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_CollectionImage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_assets_js_sticky_headers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_assets_js_sticky_headers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_assets_js_sticky_headers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prismic_io__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prismic_io___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prismic_io__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_js_getRespImgSrc__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_js_getRespImgSrc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_assets_js_getRespImgSrc__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Spread',
  props: ['window', 'mobile', 'variant', 'header', 'text', 'imagesetId'],
  components: {
    CollectionImage: __WEBPACK_IMPORTED_MODULE_1_components_CollectionImage___default.a
  },
  data: function data() {
    return {
      imageset: null
    };
  },

  computed: {
    classes: function classes() {
      return {
        'collection-spread': true,
        'collection-topic': this.variant && this.variant.indexOf('topic') > -1,
        'collection-topic--static': this.variant && this.variant.indexOf('topic') > -1 && this.images.length < 2,
        'collection-topic--flipped': this.variant && this.variant.indexOf('reverse') > -1
      };
    },
    images: function images() {
      return this.imageset ? this.imageset.getGroup('imageset.images').value : null;
    },
    mobileImage: function mobileImage() {
      return {
        type: null,
        src: this.imageset.getImage('imageset.mobile-image') ? __WEBPACK_IMPORTED_MODULE_4_assets_js_getRespImgSrc___default()(this.imageset, 'imageset.mobile-image', 'imageset-mobile') : null,
        caption: this.imageset.getStructuredText('imageset.mobile-image--caption') ? this.imageset.getStructuredText('imageset.mobile-image--caption').asHtml(__WEBPACK_IMPORTED_MODULE_0_src_config___default.a.prismic.links) : ''
      };
    },
    mobileImageBleed: function mobileImageBleed() {
      return this.imageset.data['imageset.mobile-image--bleed'] ? this.imageset.getBoolean('imageset.mobile-image--bleed') : false;
    }
  },
  methods: {
    getImageset: function getImageset() {
      var _this = this;

      if (this.imagesetId) {
        __WEBPACK_IMPORTED_MODULE_3_prismic_io___default.a.api(__WEBPACK_IMPORTED_MODULE_0_src_config___default.a.prismic.api_url).then(function (api) {
          return api.getByID(_this.imagesetId);
        }).then(function (response) {
          _this.imageset = response;
        }, function (err) {
          console.log('Error getting Imageset: ', err);
        });
      }
    },
    buildImgObj: function buildImgObj(image) {
      var type = null;
      var src = null;

      if (image.getImage('image')) {
        src = __WEBPACK_IMPORTED_MODULE_4_assets_js_getRespImgSrc___default()(image, 'image');
      }

      var interactiveImg = image.fragments['interactive-image'];
      if (interactiveImg && interactiveImg.type === 'interactive-image') {
        type = 'image-360';
        src = interactiveImg.id;
      }
      var img = {
        type: type,
        src: src,
        caption: image.data['caption'] ? image.getStructuredText('caption').asHtml(__WEBPACK_IMPORTED_MODULE_0_src_config___default.a.prismic.links) : null,
        alt: image.data['caption'] ? image.getText('caption') : '',
        table: {
          header: image.getText('table--header'),
          text: image.data['table--text'] ? image.getStructuredText('table--text').asHtml(__WEBPACK_IMPORTED_MODULE_0_src_config___default.a.prismic.links) : null
        }
      };
      return img;
    },
    onScroll: function onScroll() {
      var sticky = this.$refs.stickyheader;
      if (sticky && !window.Modernizr.cssstickyposition && window.innerWidth > this.window.bkpt.mobile) {
        __WEBPACK_IMPORTED_MODULE_2_assets_js_sticky_headers___default()(sticky, window.pageYOffset, this.window.height);
      }
    }
  },
  created: function created() {
    this.getImageset();
    window.addEventListener('scroll', this.onScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.onScroll);
  }
});

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CollectionStoryText',
  props: ['variant', 'header', 'text'],
  data: function data() {
    return {};
  },

  computed: {
    texxt: function texxt() {
      switch (this.variant) {
        case 'quote':
          var lastP = this.text.lastIndexOf('</');
          var qtSrc = ' <span class="quote-source">' + this.header + '</span>';
          return lastP > -1 ? this.text.slice(0, lastP) + qtSrc + this.text.slice(lastP) : this.text + qtSrc;
        default:
          return this.header ? '<h3>' + this.header + '</h3>' + this.text : this.text;
      }
    }
  }
});

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assets_js_sticky_headers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assets_js_sticky_headers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assets_js_sticky_headers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_SubscribeForm__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_SubscribeForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_src_components_SubscribeForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Footer__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_src_components_Footer__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'collections',
  props: ['window', 'site', 'collections'],
  components: {
    SubscribeForm: __WEBPACK_IMPORTED_MODULE_2_src_components_SubscribeForm___default.a,
    Appfooter: __WEBPACK_IMPORTED_MODULE_3_src_components_Footer___default.a
  },
  data: function data() {
    return {
      stickyHeaders: []
    };
  },

  computed: {
    mailchimpNewsletterID: function mailchimpNewsletterID() {
      return this.site ? this.site.getText('site.mailchimp-newsletter-id') : '';
    },
    collectionsSorted: function collectionsSorted() {
      return this.collections.sort(function (a, b) {
        var aNum = a.getText('collection.number') ? a.getText('collection.number') : 999;
        var bNum = b.getText('collection.number') ? b.getText('collection.number') : 999;
        if (aNum && bNum) {
          return aNum - bNum;
        }
        return 0;
      });
    }
  },
  methods: {
    isBespoke: function isBespoke(item) {
      if (item.slug === 'bespoke-service') {
        return true;
      }
    },
    isHidden: function isHidden(item) {
      var data = item.data['collection.visible'];
      return data && data.value === 'false';
    },
    respImgUrl: function respImgUrl(photo) {
      var w = window.innerWidth;
      if (w > 1600) {
        return photo.getImage('image').url;
      }
      var size = w > 1024 ? 'laptop' : 'tablet';
      return photo.getImageView('image', size).url;
    },
    onScroll: function onScroll() {
      if (!window.Modernizr.cssstickypositifon && window.innerWidth > this.window.bkpt.mobile) {
        __WEBPACK_IMPORTED_MODULE_1_assets_js_sticky_headers___default()(this.stickyHeaders, window.pageYOffset, this.window.height);
      }
    },
    detectSafari: function detectSafari() {
      if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
        document.getElementsByTagName('html')[0].setAttribute('data-browser', 'safari');
      }
    }
  },
  mounted: function mounted() {
    this.stickyHeaders = this.$el.querySelectorAll('.sticky-header');
    this.detectSafari();
  },
  created: function created() {
    window.addEventListener('scroll', this.onScroll);
    __WEBPACK_IMPORTED_MODULE_0_vue___default.a.updateMeta.setTitle('Collections');
    __WEBPACK_IMPORTED_MODULE_0_vue___default.a.updateMeta.setDescription();
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.onScroll);
  }
});

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Credits',
  data: function data() {
    return {
      creditsVisible: false
    };
  }
});

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_FooterLinks__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_FooterLinks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_src_components_FooterLinks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_SubscribeForm__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_SubscribeForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_src_components_SubscribeForm__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AppFooter',
  props: ['site'],
  components: {
    Links: __WEBPACK_IMPORTED_MODULE_0_src_components_FooterLinks___default.a,
    SubscribeForm: __WEBPACK_IMPORTED_MODULE_1_src_components_SubscribeForm___default.a
  }
});

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FooterLink',
  props: ['links'],
  data: function data() {
    return {};
  },

  methods: {
    internalRt: function internalRt(type, slug) {
      if (!slug || !type) return;
      var name = type === 'collection' ? 'Collection' : 'Page';
      return {
        name: name,
        params: {
          slug: slug
        }
      };
    }
  }
});

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CloseIcon'
});

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_src_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_throttle__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prismic_io__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prismic_io___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prismic_io__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assets_js_getRespImgSrc__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assets_js_getRespImgSrc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_assets_js_getRespImgSrc__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InteractiveImage',
  props: ['id', 'alt'],
  data: function data() {
    return {
      images: null,
      defaultImgSet: false,
      mobileImgSrc: false,
      loadImgs: window.innerWidth > __WEBPACK_IMPORTED_MODULE_0_src_config___default.a.bkpt.image360 && !this.$route.meta.hide360Images,
      bounding: null,
      resizeTimeout: null,
      grayscale: true
    };
  },

  watch: {
    '$route': function $route(to, from) {
      if (window.innerWidth > __WEBPACK_IMPORTED_MODULE_0_src_config___default.a.bkpt.image360 && !to.meta.firstPage) this.loadImgs = true;
    }
  },
  methods: {
    setImgSrc: function setImgSrc(image) {
      return __WEBPACK_IMPORTED_MODULE_3_assets_js_getRespImgSrc___default()(image, 'image');
    },
    setImgVisiblity: function setImgVisiblity(image) {
      return image.fragments['default-image'] ? image.getBoolean('default-image') : false;
    },
    getImages: function getImages() {
      var _this = this;

      if (this.id) {
        __WEBPACK_IMPORTED_MODULE_2_prismic_io___default.a.api(__WEBPACK_IMPORTED_MODULE_0_src_config___default.a.prismic.api_url).then(function (api) {
          return api.getByID(_this.id);
        }).then(function (response) {
          _this.buildImages(response.getGroup('interactive-image.images').value);
        }, function (err) {
          console.log('Error getting Interactive Image: ', err);
        });
      }
    },
    buildImages: function buildImages(images) {
      var imgs = [];
      for (var i = 0; i < images.length; i++) {
        var img = {};
        img.src = __WEBPACK_IMPORTED_MODULE_3_assets_js_getRespImgSrc___default()(images[i], 'image');
        img.visible = images[i].fragments['default-image'] ? images[i].getBoolean('default-image') : false;
        this.mobileImgSrc = img.visible ? img.src : this.mobileImgSrc;
        imgs.push(img);
      }
      this.images = imgs;
    },
    toggleImagesByXPos: function toggleImagesByXPos(offsetX) {
      if (this.loadImgs) {
        var boxWidth = this.$refs.container.offsetWidth;
        var sliceQuotient = boxWidth / this.images.length;

        var index = Math.floor(offsetX / sliceQuotient);
        index = index < 0 ? 0 : index;
        index = index > this.images.length - 1 ? this.images.length - 1 : index;
        this.images.map(function (item) {
          item.visible = false;
        });
        this.images[index].visible = true;
      }
    },
    setBounding: function setBounding() {
      if (this.$refs.container) this.bounding = this.$refs.container.getBoundingClientRect();
    },

    onMousemove: __WEBPACK_IMPORTED_MODULE_1_lodash_throttle___default()(function (e) {
      this.toggleImagesByXPos(e.offsetX);
    }, 0),
    onTouchmove: __WEBPACK_IMPORTED_MODULE_1_lodash_throttle___default()(function (e) {
      var x = e.changedTouches[0].pageX - this.bounding.left;
      this.toggleImagesByXPos(x);
    }, 50),
    onResize: function onResize() {
      var _this2 = this;

      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(function () {
        _this2.setBounding();
      }, 300);
    }
  },
  created: function created() {
    this.getImages();
    window.addEventListener('resize', this.onResize);
  },
  updated: function updated() {
    if (this.bounding === null) this.setBounding();
  },
  destroyed: function destroyed() {
    clearTimeout(this.resizeTimeout);
    window.removeEventListener('resize', this.onResize);
  }
});

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VideoBackground__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VideoBackground___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__VideoBackground__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Footer__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Footer__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'intro',
  props: ['mobile', 'siteIntro', 'site', 'collections'],
  components: {
    Cinemagraph: __WEBPACK_IMPORTED_MODULE_1__VideoBackground___default.a,
    Footerr: __WEBPACK_IMPORTED_MODULE_2__Footer___default.a
  },
  data: function data() {
    return {
      blurVideo: true
    };
  },
  metaInfo: function metaInfo() {
    return {
      meta: [{ name: 'description', content: this.site ? this.site.getText('site.meta_description') : '' }, { name: 'keywords', content: this.site ? this.site.getText('site.meta_keywords') : '' }, { property: 'og:title', content: document.title ? document.title : 'Dovedale Design Studio' }, { property: 'og:description', content: this.site ? this.site.getText('site.meta_description') : '' }, { property: 'og:image', content: this.site ? this.site.data['site.share_image'].value.main.url : '' }, { name: 'twitter:title', content: this.site ? this.site.getText('site.tagline') : '' }, { name: 'twitter:title', content: document.title ? document.title : 'Dovedale Design Studio' }, { name: 'twitter:description', content: this.site ? this.site.getText('site.meta_description') : '' }, { name: 'twitter:image:src', content: this.site ? this.site.data['site.share_image'].value.main.url : '' }, { itemprop: 'name', content: document.title ? document.title : 'Dovedale Design Studio' }, { itemprop: 'description', content: this.site ? this.site.getText('site.meta_description') : '' }, { itemprop: 'image', content: this.site ? this.site.data['site.share_image'].value.main.url : '' }]
    };
  },

  computed: {
    headerText: function headerText() {
      return this.site ? this.site.getText('site.header') : '';
    },
    subheaderText: function subheaderText() {
      return this.site ? this.site.getText('site.subheader') : '';
    },
    notesVisible: function notesVisible() {
      return this.$route.name === 'Notes';
    },
    titleTransition: function titleTransition() {
      return this.siteIntro ? 'longfade' : 'fadeinplace';
    }
  },
  watch: {
    '$route': function $route(to, from) {
      this.$emit('toggleNav');
    },
    site: function site() {
      this.updateMeta();
    }
  },
  methods: {
    isHidden: function isHidden(item) {
      return item.data['collection.hide-on-index'] ? item.getBoolean('collection.hide-on-index') : false;
    },
    showNotes: function showNotes() {
      this.$router.push({ name: 'Notes' });
    },
    cinemagraphPlaying: function cinemagraphPlaying() {
      this.blurVideo = false;
      this.$emit('cinemagraph-playing');
    },
    updateMeta: function updateMeta() {
      __WEBPACK_IMPORTED_MODULE_0_vue___default.a.updateMeta.setTitle();
      __WEBPACK_IMPORTED_MODULE_0_vue___default.a.updateMeta.setDescription();
    }
  },
  created: function created() {
    if (this.$route.name === 'Notes') this.$emit('toggleNav');
    this.updateMeta();
  }
});

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'logoMarque'
});

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LogoMarque__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LogoMarque___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__LogoMarque__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AppNav',
  props: ['site', 'window', 'collections'],
  components: {
    Logo: __WEBPACK_IMPORTED_MODULE_0__LogoMarque___default.a
  },
  data: function data() {
    return {
      firstPage: true,
      navCondensed: false,
      mobileNavVisible: false,
      taglineVisible: false,
      collectionsVisible: false
    };
  },

  computed: {
    iconVisibile: function iconVisibile() {
      return !(this.firstPage && this.$route.name === 'Page');
    }
  },
  watch: {
    '$route': function $route() {
      this.firstPage = false;
      this.mobileNavVisible = false;
      this.collectionsVisible = false;
    },
    mobileNavVisible: function mobileNavVisible(visible) {
      if (!visible) this.collectionsVisible = false;
    }
  },
  methods: {
    navLinkRt: function navLinkRt(key) {
      if (!this.site) return '/';
      var link = this.site.data[key];
      if (link.value.document.type === 'page') return { name: 'Page', params: { slug: link.value.document.uid } };
      return '/';
    },
    onScroll: function onScroll() {
      var pageY = window.pageYOffset;
      this.navCondensed = pageY > 25;
    },
    iconClick: function iconClick() {
      if (this.$route.name === 'Page') {
        this.$router.back();
      } else {
        this.navCondensed = !this.navCondensed;
      }
    },
    closePage: function closePage() {
      if (this.firstPage) {
        this.$router.push({ name: 'Intro' });
      } else {
        this.$router.back();
      }
    }
  },
  created: function created() {
    window.addEventListener('scroll', this.onScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.onScroll);
  }
});

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_src_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LogoMarque__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LogoMarque___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__LogoMarque__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SubscribeForm__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SubscribeForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SubscribeForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Credits__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Credits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_src_components_Credits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Footer__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Footer__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'notes',
  props: ['mobile', 'site'],
  components: {
    Logo: __WEBPACK_IMPORTED_MODULE_1__LogoMarque___default.a,
    SubscribeForm: __WEBPACK_IMPORTED_MODULE_2__SubscribeForm___default.a,
    Credits: __WEBPACK_IMPORTED_MODULE_3_src_components_Credits___default.a,
    AppFooter: __WEBPACK_IMPORTED_MODULE_4__Footer___default.a
  },
  data: function data() {
    return {};
  },

  computed: {
    mailchimpNewsletterID: function mailchimpNewsletterID() {
      return this.site ? this.site.getText('site.mailchimp-newsletter-id') : '';
    }
  },
  methods: {
    html: function html(key) {
      return this.site.getStructuredText(key).asHtml(__WEBPACK_IMPORTED_MODULE_0_src_config___default.a.prismic.links);
    },
    hideNotes: function hideNotes() {
      if (this.$route.meta.firstPage) {
        this.$router.push({ name: 'Intro' });
      } else {
        this.$router.go(-1);
      }
    }
  },
  created: function created() {
    document.title = 'Notes | ' + __WEBPACK_IMPORTED_MODULE_0_src_config___default.a.title;
  }
});

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_src_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prismic_io__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prismic_io___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prismic_io__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_PageBody__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_PageBody___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_src_components_PageBody__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_SubscribeForm__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_SubscribeForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_src_components_SubscribeForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Button_Boxed__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Button_Boxed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_src_components_Button_Boxed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Footer__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_src_components_Footer__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'page',
  props: ['slug', 'site'],
  components: {
    PageBody: __WEBPACK_IMPORTED_MODULE_3_src_components_PageBody___default.a,
    SubscribeForm: __WEBPACK_IMPORTED_MODULE_4_src_components_SubscribeForm___default.a,
    EnquireBtn: __WEBPACK_IMPORTED_MODULE_5_src_components_Button_Boxed___default.a,
    Appfooter: __WEBPACK_IMPORTED_MODULE_6_src_components_Footer___default.a
  },
  data: function data() {
    return {
      page: null,
      pageNotFound: false,
      email: __WEBPACK_IMPORTED_MODULE_1_src_config___default.a.email
    };
  },
  metaInfo: function metaInfo() {
    return {
      meta: [{ name: 'description', content: this.site ? this.site.getText('site.meta_description') : '' }, { name: 'keywords', content: this.site ? this.site.getText('site.meta_keywords') : '' }, { property: 'og:title', content: document.title ? document.title : 'Dovedale Design Studio' }, { property: 'og:description', content: this.site ? this.site.getText('site.meta_description') : '' }, { property: 'og:image', content: this.site ? this.site.data['site.share_image'].value.main.url : '' }, { name: 'twitter:title', content: this.site ? this.site.getText('site.tagline') : '' }, { name: 'twitter:title', content: document.title ? document.title : 'Dovedale Design Studio' }, { name: 'twitter:description', content: this.site ? this.site.getText('site.meta_description') : '' }, { name: 'twitter:image:src', content: this.site ? this.site.data['site.share_image'].value.main.url : '' }, { itemprop: 'name', content: document.title ? document.title : 'Dovedale Design Studio' }, { itemprop: 'description', content: this.site ? this.site.getText('site.meta_description') : '' }, { itemprop: 'image', content: this.site ? this.site.data['site.share_image'].value.main.url : '' }]
    };
  },

  computed: {
    mailchimpNewsletterID: function mailchimpNewsletterID() {
      return this.site ? this.site.getText('site.mailchimp-newsletter-id') : '';
    },
    fontStyle: function fontStyle() {
      if (!this.page) return 'serif';
      var data = this.page.data['page.font_style'];
      return data ? data.value : 'serif';
    },
    showEnquireBtn: function showEnquireBtn() {
      return this.getPageFieldValue(this.page, 'page.show_contact_button') === 'true';
    },
    showNewsletterForm: function showNewsletterForm() {
      return this.getPageFieldValue(this.page, 'page.show_newsletter_form') === 'true';
    }
  },
  watch: {
    slug: function slug() {
      this.getPage();
    },
    page: function page(_page) {
      var _this = this;

      if (!_page) return;
      this.$nextTick(function () {
        return _this.loadAtHash();
      });
      this.setTheme();
      this.updateMeta();
    }
  },
  methods: {
    getPageFieldValue: function getPageFieldValue(doc) {
      var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
      return doc && doc.data && doc.data[key] && doc.data[key].value;
    },
    html: function html(doc, key) {
      return doc ? doc.getStructuredText(key).asHtml(__WEBPACK_IMPORTED_MODULE_1_src_config___default.a.prismic.links) : '';
    },
    text: function text(doc, key) {
      return doc ? doc.getText(key) : '';
    },
    loadAtHash: function loadAtHash() {
      if (this.$route.hash) {
        var el = this.$el.querySelector(this.$route.hash);
        if (el) window.scrollTo(0, el.getBoundingClientRect().top);
      }
    },
    getPage: function getPage() {
      var _this2 = this;

      if (!this.slug) {
        this.pageNotFound = true;
        return;
      }
      this.page = null;
      __WEBPACK_IMPORTED_MODULE_2_prismic_io___default.a.api(__WEBPACK_IMPORTED_MODULE_1_src_config___default.a.prismic.api_url).then(function (api) {
        return api.getByUID('page', _this2.slug);
      }).then(function (response) {
        if (response) {
          _this2.page = response;
          if (_this2.site) document.title = _this2.page.getText('page.title') + ' | ' + __WEBPACK_IMPORTED_MODULE_1_src_config___default.a.title;
        } else {
          _this2.pageNotFound = true;
        }
      }, function (err) {
        console.log('Error getting Page: ', err);
      });
    },
    updateMeta: function updateMeta() {
      if (!this.page) return;
      __WEBPACK_IMPORTED_MODULE_0_vue___default.a.updateMeta.setTitle(this.page.getText('page.title'));
      var descrip = this.page.getText('page.meta_description');
      if (descrip && descrip.length > 0) __WEBPACK_IMPORTED_MODULE_0_vue___default.a.updateMeta.setDescription(descrip);
    },
    setTheme: function setTheme() {
      if (!this.page || !this.page.data || !this.page.data['page.theme']) return;
      var theme = this.page.data['page.theme'];
      theme = theme && theme.value ? theme.value : 'light';
      this.$emit('changeTheme', theme);
    }
  },
  created: function created() {
    this.getPage();
  },
  mounted: function mounted() {
    this.loadAtHash();
  }
});

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_Credits__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_Credits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_src_components_Credits__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PageBody',
  props: ['title', 'body', 'footHead', 'footBody', 'showCredits', 'fontStyle'],
  components: {
    Credits: __WEBPACK_IMPORTED_MODULE_0_src_components_Credits___default.a
  },
  data: function data() {
    return {
      creditsVisible: false
    };
  }
});

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_Collection_SKUs__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_Collection_SKUs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_src_components_Collection_SKUs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_LogoMarque__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_LogoMarque___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_src_components_LogoMarque__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CollectionSKUs',
  components: { CollectionItems: __WEBPACK_IMPORTED_MODULE_0_src_components_Collection_SKUs___default.a, LogoMarque: __WEBPACK_IMPORTED_MODULE_1_src_components_LogoMarque___default.a },
  props: {
    collections: Array
  },
  data: function data() {
    return {
      slugs: ['knives', 'humidor', 'watch-box', 'jameson-suite', 'chess-set1'],

      cart: null
    };
  }
});

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LogoMarque__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LogoMarque___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__LogoMarque__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VideoBackground__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VideoBackground___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__VideoBackground__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'screensaver',
  props: ['sleepMode', 'siteIntro'],
  components: {
    Marque: __WEBPACK_IMPORTED_MODULE_0__LogoMarque___default.a,
    Cinemagraph: __WEBPACK_IMPORTED_MODULE_1__VideoBackground___default.a
  },
  data: function data() {
    return {
      showTagline: false
    };
  }
});

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_imagesloaded__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_imagesloaded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_imagesloaded__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assets_js_resizeShopifyImgUrl__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assets_js_resizeShopifyImgUrl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assets_js_resizeShopifyImgUrl__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'slideshow',
  props: ['images'],
  data: function data() {
    return {
      slides: [],
      current: 0,
      autoplay: null
    };
  },

  methods: {
    next: function next() {
      this.current++;
      this.current = this.current % this.slides.length;
    },
    previous: function previous() {
      this.current--;
      this.current = this.current === -1 ? this.slides.length - 1 : this.current;
    },
    startAutoplay: function startAutoplay() {
      var _this = this;

      this.autoplay = setInterval(function () {
        _this.next();
      }, 3000);
    },
    slide: function slide(direction) {
      clearInterval(this.autoplay);
      this[direction]();
      this.startAutoplay();
    },
    shopifyImg: function shopifyImg(src) {
      var size = window.innerWidth > 600 ? 1024 : 600;
      return __WEBPACK_IMPORTED_MODULE_1_assets_js_resizeShopifyImgUrl___default()(src, size);
    }
  },
  created: function created() {
    for (var i = 0; i < this.images.length; i++) {
      var slide = {};
      slide.src = this.images[i].src;
      slide.visible = i === 0;
      this.slides.push(slide);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.startAutoplay();

    __WEBPACK_IMPORTED_MODULE_0_imagesloaded___default()(this.$refs.container, function () {
      _this2.$emit('imgsloaded');
    });
  },
  destroyed: function destroyed() {
    clearInterval(this.autoplay);
  }
});

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'slideshowBackground',
  props: ['srcs'],
  data: function data() {
    return {
      current: 0,
      autoplay: null
    };
  },

  methods: {
    play: function play() {
      var _this = this;

      this.autoplay = setInterval(function () {
        _this.current++;
        _this.current = _this.current % _this.srcs.length;
      }, 3000);
    }
  },
  created: function created() {
    this.play();
  },
  destroyed: function destroyed() {
    clearInterval(this.autoplay);
  }
});

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SubscribeFrom',
  computed: {
    mailchimpNewsletterID: function mailchimpNewsletterID() {
      var site = this.$store.state.site;
      var id = site && site.data && site.data['site.mailchimp-newsletter-id'];
      return id ? site.getText('site.mailchimp-newsletter-id') : '';
    }
  },
  methods: {
    submit: function submit() {
      this.$emit('submit');
      this.$el.querySelector('form').submit();
    }
  }
});

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__IconClose__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__IconClose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__IconClose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SubscribeForm__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SubscribeForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SubscribeForm__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SubscribePopUp',
  props: ['ready'],
  components: { SubscribeForm: __WEBPACK_IMPORTED_MODULE_1__SubscribeForm___default.a, CloseIcon: __WEBPACK_IMPORTED_MODULE_0__IconClose___default.a },
  data: function data() {
    return {
      visible: false,
      unwatch: null
    };
  },

  computed: {
    enabled: function enabled() {
      var site = this.$store.state.site;
      var field = site && site.data ? site.data['site.popup_subscribe_enabled'] : false;
      return field && field.value === 'true';
    }
  },
  methods: {
    reveal: function reveal() {
      var _this = this;

      setTimeout(function () {
        _this.visible = true;
        _this.unwatch();
      }, 12000);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.unwatch = this.$watch('enabled', function () {
      if (_this2.ready) return _this2.reveal();
      _this2.unwatch = _this2.$watch('ready', _this2.reveal);
    });
  }
});

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SlideshowBackground__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SlideshowBackground___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__SlideshowBackground__);


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cinemagraph',
  props: ['site', 'blur', 'lowRes'],
  components: {
    Slideshow: __WEBPACK_IMPORTED_MODULE_0__SlideshowBackground___default.a
  },
  data: function data() {
    return {
      showSlideshow: false,
      blurEnabled: window.navigator.userAgent.indexOf('Firefox') === -1
    };
  },

  computed: {
    src: function src() {
      if (this.site) {
        var key = window.innerWidth > 1024 || window.outerHeight > 768 ? 'site.cinemagraph' : 'site.cinemagraph--mobile';
        return this.site.data[key].value.file.url;
      }
    },
    stills: function stills() {
      if (this.site) {
        var srcs = [];
        var images = this.site.getGroup('site.cinemagraph--mobile-stills').toArray();
        for (var i = 0; i < images.length; i++) {
          srcs.push(images[i].getImage('images').url);
        }
        return srcs;
      }
    }
  },
  methods: {
    play: function play() {
      var _this = this;

      var promise = this.$el.querySelector('video').play();
      if (promise !== 'undefined') {
        promise.catch(function (error) {
          console.error(error);
          _this.showSlideshow = true;
          _this.$emit('playing');
        }).then(function () {
          _this.$emit('playing');
        });
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(this.play);
  }
});

/***/ }),
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 207 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 210 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 211 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 212 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 213 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 214 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 215 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 216 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 217 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 218 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 219 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 220 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 221 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 222 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 223 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 224 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 225 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 226 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 227 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 228 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 229 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 230 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 231 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 232 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 233 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 234 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 235 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(210)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(376),
  /* scopeId */
  "data-v-15a7aadc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(228)
__webpack_require__(229)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(129),
  /* template */
  __webpack_require__(394),
  /* scopeId */
  "data-v-7a052fea",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(204)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(370),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(209)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(133),
  /* template */
  __webpack_require__(375),
  /* scopeId */
  "data-v-1579641a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(211)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(134),
  /* template */
  __webpack_require__(377),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(230)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(135),
  /* template */
  __webpack_require__(395),
  /* scopeId */
  "data-v-a609e394",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(234)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(136),
  /* template */
  __webpack_require__(399),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(223)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(389),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(206)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(138),
  /* template */
  __webpack_require__(372),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(207)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(139),
  /* template */
  __webpack_require__(373),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(227)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(393),
  /* scopeId */
  "data-v-6b67230e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(225)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(391),
  /* scopeId */
  "data-v-66e7217c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(213)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(144),
  /* template */
  __webpack_require__(379),
  /* scopeId */
  "data-v-363fdbe3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(219)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(145),
  /* template */
  __webpack_require__(385),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(203)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(146),
  /* template */
  __webpack_require__(369),
  /* scopeId */
  "data-v-027ef4d0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(218)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(148),
  /* template */
  __webpack_require__(384),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(208)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(149),
  /* template */
  __webpack_require__(374),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(226)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(150),
  /* template */
  __webpack_require__(392),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(214)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(151),
  /* template */
  __webpack_require__(380),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(224)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(152),
  /* template */
  __webpack_require__(390),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(216)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(153),
  /* template */
  __webpack_require__(382),
  /* scopeId */
  "data-v-4190308d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(221)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(154),
  /* template */
  __webpack_require__(387),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(215)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(155),
  /* template */
  __webpack_require__(381),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(212)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(157),
  /* template */
  __webpack_require__(378),
  /* scopeId */
  "data-v-3626c2ee",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 369 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.site) ? _c('section', {
    attrs: {
      "id": "intro"
    }
  }, [_c('header', {
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'Collections'
        })
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.titleTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.siteIntro && !_vm.notesVisible),
      expression: "!siteIntro && !notesVisible"
    }],
    staticClass: "title"
  }, [_c('h1', {
    staticClass: "h1"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Collections'
      }
    }
  }, [_vm._v(_vm._s(_vm.headerText))])], 1), _vm._v(" "), _c('h2', {
    staticClass: "h5 century-mono"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Collections'
      }
    }
  }, [_vm._v(_vm._s(_vm.subheaderText))])], 1)])]), _vm._v(" "), _c('cinemagraph', {
    attrs: {
      "site": _vm.site,
      "blur": _vm.siteIntro || _vm.notesVisible || _vm.blurVideo
    },
    on: {
      "playing": _vm.cinemagraphPlaying
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view', {
    attrs: {
      "mobile": _vm.mobile,
      "site": _vm.site
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.titleTransition
    }
  }, [_c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.siteIntro),
      expression: "!siteIntro"
    }],
    staticClass: "intro__asterisk",
    attrs: {
      "to": {
        name: 'Notes'
      }
    }
  }, [_c('span', {
    staticClass: "icon-asterisk"
  })])], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 370 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "product-overlay"
  }, [_c('nav', {
    staticClass: "nav is-hidden-tablet",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "nav__mobile-header"
  }, [_c('button', {
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('span', {
    staticClass: "icon icon--close"
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "home-link",
    attrs: {
      "title": "Home",
      "to": {
        name: 'Intro'
      }
    }
  }, [_c('logo')], 1)], 1)]), _vm._v(" "), (_vm.product) ? _c('div', {
    staticClass: "inner"
  }, [_c('header', {
    staticClass: "mobile-header"
  }, [_c('h1', [_vm._v(_vm._s(_vm.product.title))])]), _vm._v(" "), _c('section', {
    staticClass: "section left"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "slideshow-outer"
  }, [_c('slideshow', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.slideshowVisible),
      expression: "slideshowVisible"
    }],
    attrs: {
      "images": _vm.product.images
    },
    on: {
      "imgsloaded": function($event) {
        _vm.slideshowVisible = true
      }
    }
  }), _vm._v(" "), (!_vm.slideshowVisible && _vm.preloadImg) ? _c('img', {
    staticClass: "preload-img",
    attrs: {
      "src": _vm.preloadImg
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('section', {
    staticClass: "section right h7 nimbus-sans"
  }, [_c('h2', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.slideshowVisible || _vm.preloadImg),
      expression: "slideshowVisible || preloadImg"
    }],
    staticClass: "description-title title-case"
  }, [_vm._v(_vm._s(_vm.product.title))]), _vm._v(" "), _c('section', {
    domProps: {
      "innerHTML": _vm._s(_vm.product.descriptionHtml + _vm.priceHTML)
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "actions"
  }, [(_vm.cart) ? [_c('li', [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addToCart.apply(null, arguments)
      }
    }
  }, [_vm._v("ADD "), (!_vm.cartItem) ? _c('span', [_vm._v("TO CART")]) : _vm._e()]), _vm._v(" "), (_vm.cartItem) ? _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateCartItem(-1)
      }
    }
  }, [_vm._v("DEDUCT")]) : _vm._e()]), _vm._v(" "), (_vm.cartTotalCount > 0) ? _c('li', [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.clear.apply(null, arguments)
      }
    }
  }, [_vm._v("CLEAR")]), _vm._v(" "), _c('a', {
    staticClass: "checkout-btn",
    attrs: {
      "href": _vm.cart.webUrl
    }
  }, [_vm._v("CHECKOUT "), _c('span', {
    staticClass: "counter"
  }, [_vm._v(_vm._s(_vm.cartTotalCount))])])]) : _vm._e()] : [_vm._m(0)]], 2)])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "close h9 icon-close-overlay",
    attrs: {
      "title": "Close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.close.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "close-mobile ui-nw-icon",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.close.apply(null, arguments)
      }
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "mailto:info@dovedaledesignstudio.com"
    }
  }, [_vm._v("ENQUIRE")])])
}]}

/***/ }),
/* 371 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "app",
    attrs: {
      "id": "app",
      "data-route": _vm.$route.name,
      "data-theme": _vm.theme
    },
    on: {
      "mousemove": _vm.resetSleepTimer
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.navTransition
    }
  }, [_c('app-header', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.siteIntro && _vm.navVisible),
      expression: "!siteIntro && navVisible"
    }],
    attrs: {
      "window": _vm.window,
      "siteIntro": _vm.siteIntro,
      "site": _vm.site,
      "collections": _vm.collections
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "app__body"
  }, [_c('transition', {
    attrs: {
      "name": _vm.pageTransition
    }
  }, [_c('router-view', {
    attrs: {
      "window": _vm.window,
      "mobile": _vm.isMobile,
      "siteIntro": _vm.siteIntro,
      "site": _vm.site,
      "collections": _vm.collections
    },
    on: {
      "toggleNav": function($event) {
        _vm.navVisible = !_vm.navVisible
      },
      "cinemagraph-playing": _vm.endIntro,
      "changeTheme": _vm.changeTheme
    }
  })], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "longfade"
    }
  }, [(_vm.siteIntro || _vm.sleepMode.active) ? _c('screensaver', {
    attrs: {
      "sleepMode": _vm.sleepMode.active,
      "siteIntro": _vm.siteIntro,
      "site": _vm.site
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('subscribe-pop-up', {
    attrs: {
      "ready": _vm.siteReady
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 372 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.images) ? _c('div', {
    class: _vm.classes
  }, [(_vm.variant === 'topic' || _vm.variant === 'topic - reverse') ? [(_vm.mobile && _vm.mobileImage.src) ? _c('collection-image', {
    class: ['collection-spread-mobile-img', {
      'collection-spread-mobile-img--bleed': _vm.mobileImageBleed
    }],
    attrs: {
      "image": _vm.mobileImage
    }
  }) : _vm._e(), _vm._v(" "), _c('section', {
    ref: "stickyheader",
    class: ['collection-spread--column', 'collection-topic-text', {
      'sticky-header': _vm.images.length > 1
    }]
  }, [_c('div', {
    staticClass: "collection-spread--row"
  }, [_c('h2', {
    staticClass: "h2 uppercase"
  }, [_vm._v(_vm._s(_vm.header))]), _vm._v(" "), _c('div', {
    staticClass: "h6 textbody justify-center",
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  })])]), _vm._v(" "), (!_vm.mobile) ? _c('section', {
    staticClass: "collection-spread--column"
  }, _vm._l((_vm.images), function(image) {
    return _c('div', {
      staticClass: "collection-spread--row"
    }, [_c('collection-image', {
      attrs: {
        "image": _vm.buildImgObj(image)
      }
    })], 1)
  }), 0) : _vm._e()] : _vm._l((_vm.images), function(image, index) {
    return (index < 2) ? _c('section', {
      staticClass: "collection-spread--column"
    }, [_c('div', {
      staticClass: "collection-spread--row"
    }, [_c('collection-image', {
      attrs: {
        "image": _vm.buildImgObj(image)
      }
    })], 1)]) : _vm._e()
  })], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 373 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "inner"
  }, [(_vm.variant === 'quote') ? [_c('blockquote', {
    domProps: {
      "innerHTML": _vm._s(_vm.texxt)
    }
  })] : [_c('div', {
    staticClass: "textbody",
    domProps: {
      "innerHTML": _vm._s(_vm.texxt)
    }
  })]], 2)])
},staticRenderFns: []}

/***/ }),
/* 374 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    attrs: {
      "id": "notes"
    },
    on: {
      "click": _vm.hideNotes
    }
  }, [_c('nav', {
    staticClass: "nav is-hidden-tablet",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "nav__mobile-header"
  }, [_c('button', {
    on: {
      "click": _vm.hideNotes
    }
  }, [_c('span', {
    staticClass: "icon icon--close"
  })]), _vm._v(" "), _c('a', {
    staticClass: "home-link",
    attrs: {
      "title": "Home"
    },
    on: {
      "click": _vm.hideNotes
    }
  }, [_c('logo')], 1)])]), _vm._v(" "), _c('section', {
    staticClass: "inner",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('article', {
    staticClass: "textbody justify-center"
  }, [_c('section', {
    staticClass: "h6plus",
    domProps: {
      "innerHTML": _vm._s(_vm.html('site.notes-text'))
    }
  }), _vm._v(" "), _c('footer', [_c('h3', [_vm._v("A Note on The Cinemagraphs")]), _vm._v(" "), _c('section', {
    staticClass: "h7 nimbus-sans",
    domProps: {
      "innerHTML": _vm._s(_vm.html('site.notes-footer'))
    }
  }), _vm._v(" "), _c('credits', {
    staticClass: "is-hidden-tablet"
  })], 1)]), _vm._v(" "), _c('footer', {
    staticClass: "is-hidden-tablet"
  }, [_c('app-footer', {
    attrs: {
      "site": _vm.site
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 375 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sku__item",
    class: {
      'sku__item--invisible': !_vm.imgLoaded
    }
  }, [_c('router-link', {
    staticClass: "inner",
    attrs: {
      "to": _vm.routerTo()
    }
  }, [(_vm.product.images.length > 0) ? _c('img', {
    attrs: {
      "src": _vm.shopifyImg(_vm.product.images[0].src),
      "alt": _vm.product.title
    },
    on: {
      "load": function($event) {
        _vm.imgLoaded = true
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "h7 uppercase"
  }, [_c('label', [_c('div', [_c('span', [_vm._v(_vm._s(_vm.product.title))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.product.variants[0].formattedPrice))])])]), _vm._v(" "), _c('button', {
    staticClass: "view-item-btn"
  }, [_c('span', [_vm._v("Purchase Item")])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 376 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "click": function($event) {
        return _vm.$emit('click')
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 377 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.sections) ? _c('section', {
    staticClass: "collection-story underline-links"
  }, _vm._l((_vm.sections), function(block, index) {
    return (_vm.showBlock(block)) ? _c(_vm.setBlock('layout', block.getText('layout')), {
      key: index,
      tag: "component",
      staticClass: "collection-story--block",
      attrs: {
        "variant": _vm.setBlock('variant', block.getText('layout')),
        "header": block.getText('header'),
        "text": _vm.html(block, 'text'),
        "imageUrl": _vm.getLandscapeImageUrl(block),
        "imageAlt": block.getText('text'),
        "imageTableHeader": block.getText('image-table--header'),
        "imageTableText": _vm.html(block, 'image-table--text'),
        "imagesetId": block.data.imageset ? block.data.imageset.value.document.id : null,
        "mobile": _vm.mobile,
        "window": _vm.window
      }
    }) : _vm._e()
  }), 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 378 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    attrs: {
      "id": "subscribe-popup"
    }
  }, [_c('transition', {
    attrs: {
      "name": "popup"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "subscribe-popup__body"
  }, [_c('close-icon', {
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }), _vm._v(" "), _c('subscribe-form', {
    on: {
      "submit": function($event) {
        _vm.visible = false
      }
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 379 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    on: {
      "click": function($event) {
        return _vm.$emit('click')
      }
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "viewBox": "0 0 16 16",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "preserveaspectratio": ""
    }
  }, [_c('line', {
    attrs: {
      "x1": "0",
      "y1": "0%",
      "x2": "100%",
      "y2": "100%",
      "stroke": "currentColor",
      "stroke-width": "1"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "0",
      "y1": "100%",
      "x2": "100%",
      "y2": "0%",
      "stroke": "currentColor",
      "stroke-width": "1"
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 380 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "pagebody"
  }, [(_vm.title) ? _c('header', [_c('h1', {
    staticClass: "h6plus",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.body) ? _c('section', {
    staticClass: "textbody h6plus",
    class: {
      'nimbus-sans': _vm.fontStyle === 'sans-serif'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.body)
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('footer', {
    staticClass: "underline-links"
  }, [(_vm.footHead) ? _c('h2', {
    staticClass: "pagebody__header h6plus",
    domProps: {
      "innerHTML": _vm._s(_vm.footHead)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.footBody) ? _c('section', {
    staticClass: "contact h7 nimbus-sans",
    domProps: {
      "innerHTML": _vm._s(_vm.footBody)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showCredits) ? _c('credits', {
    staticClass: "is-hidden-mobile"
  }) : _vm._e()], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 381 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.srcs) ? _c('div', {
    staticClass: "slideshow-background"
  }, _vm._l((_vm.srcs), function(url, index) {
    return _c('div', {
      style: ('background-image:url(' + url + ')'),
      attrs: {
        "data-visible": _vm.current === index
      }
    })
  }), 0) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 382 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vcenter-content",
    attrs: {
      "id": "screensaver"
    }
  }, [(_vm.siteIntro) ? _c('marque', {
    staticClass: "vcenter"
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "longfade"
    }
  }, [(!_vm.siteIntro) ? _c('h3', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTagline),
      expression: "showTagline"
    }],
    staticClass: "h5 century-mono vcenter"
  }, [_vm._v("\n      Contemporary Products,"), _c('br'), _vm._v("\n      Traditional Craftsmanship,"), _c('br'), _vm._v(" \n      Designed and"), _c('br'), _vm._v("\n      Conceived in London\n    ")]) : _vm._e()]), _vm._v(" "), (!_vm.siteIntro) ? _c('cinemagraph', {
    attrs: {
      "blur": true,
      "lowRes": _vm.sleepMode,
      "site": _vm.site
    },
    on: {
      "playing": function($event) {
        _vm.showTagline = true
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 383 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.site) ? _c('div', {
    staticClass: "video-background",
    class: {
      'blurred': _vm.blur && _vm.blurEnabled
    }
  }, [_c('transition', {
    attrs: {
      "name": "fadeinplace"
    }
  }, [(_vm.showSlideshow) ? _c('slideshow', {
    attrs: {
      "srcs": _vm.stills
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeinplace"
    }
  }, [_c('video', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showSlideshow),
      expression: "!showSlideshow"
    }],
    attrs: {
      "src": _vm.src,
      "muted": "",
      "loop": ""
    },
    domProps: {
      "muted": true
    },
    on: {
      "playing": function($event) {
        return _vm.$emit('playing')
      }
    }
  })])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 384 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    class: ['nav', {
      'condensed': _vm.navCondensed
    }],
    attrs: {
      "id": "nav"
    },
    on: {
      "mouseleave": function($event) {
        _vm.taglineVisible = false
      },
      "mouseenter": function($event) {
        _vm.navCondensed = false
      }
    }
  }, [_c('div', {
    staticClass: "nav__mobile-header"
  }, [_c('button', {
    attrs: {
      "id": "navToggleBtn"
    },
    on: {
      "click": function($event) {
        _vm.mobileNavVisible = !_vm.mobileNavVisible
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.mobileNavVisible),
      expression: "!mobileNavVisible"
    }],
    staticClass: "icon icon--menu"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mobileNavVisible),
      expression: "mobileNavVisible"
    }],
    staticClass: "icon icon--close"
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "home-link",
    attrs: {
      "title": "Home",
      "to": {
        name: 'Intro'
      }
    }
  }, [_c('logo')], 1), _vm._v(" "), _c('div')], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeinplace"
    }
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.taglineVisible),
      expression: "!taglineVisible"
    }],
    class: {
      'nav__pages--hidden': !_vm.mobileNavVisible
    }
  }, [_c('div', {
    staticClass: "home-link-outer"
  }, [_c('router-link', {
    staticClass: "home-link",
    attrs: {
      "title": "Home",
      "to": {
        name: 'Intro'
      }
    }
  }, [_c('div', {
    on: {
      "mouseenter": function($event) {
        _vm.taglineVisible = true
      }
    }
  }, [_c('logo')], 1)])], 1), _vm._v(" "), _c('li', [_c('button', {
    class: {
      'submenu-toggle--hidden': _vm.collectionsVisible
    },
    on: {
      "click": function($event) {
        _vm.collectionsVisible = !_vm.collectionsVisible
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Purchase'
      }
    }
  }, [_c('span', [_vm._v("Purchase")])])], 1), _vm._v(" "), _c('ul', {
    class: {
      'submenu--visible': _vm.collectionsVisible
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/collections/bespoke-service"
    }
  }, [_c('span', [_vm._v("Our Bespoke Service")])])], 1), _vm._v(" "), _vm._l((_vm.collections), function(collection) {
    return (collection.data['collection.visible'].value !== 'false' && collection.data['collection.number'].value) ? _c('li', {
      key: collection.id
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'Collection Items',
          params: {
            slug: collection.uid
          }
        }
      }
    }, [_c('span', [_vm._v("Nr " + _vm._s(collection.data['collection.number'].value) + " " + _vm._s(collection.data['collection.title'].value[0].text))])])], 1) : _vm._e()
  })], 2)]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Collections'
      }
    }
  }, [_c('span', [_vm._v("Collections")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "is-hidden-mobile"
  }), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": _vm.navLinkRt('site.nav--right-link')
    }
  }, [_c('span', [_vm._v("Information")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": _vm.navLinkRt('site.nav--contact-page')
    }
  }, [_c('span', [_vm._v("Contact")])])], 1)])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeinplace"
    }
  }, [_c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.taglineVisible),
      expression: "taglineVisible"
    }],
    staticClass: "tagline century-mono vcenter-content",
    attrs: {
      "to": {
        name: 'Intro'
      }
    }
  }, [_c('span', {
    staticClass: "vcenter"
  }, [_vm._v("\n        Contemporary Products,\n        Traditional Craftsmanship,"), _c('br'), _vm._v(" \n        Designed and Conceived in London\n      ")])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 385 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.images) ? _c('div', {
    ref: "container",
    staticClass: "interactive-image",
    attrs: {
      "data-grayscale": _vm.grayscale
    },
    on: {
      "mousemove": _vm.onMousemove,
      "touchmove": _vm.onTouchmove,
      "touchend": function($event) {
        _vm.grayscale = true
      },
      "touchstart": function($event) {
        _vm.grayscale = false
      }
    }
  }, [(_vm.loadImgs) ? _vm._l((_vm.images), function(image) {
    return _c('img', {
      attrs: {
        "src": image.src,
        "data-visible": image.visible,
        "alt": _vm.alt
      }
    })
  }) : _c('img', {
    attrs: {
      "src": _vm.mobileImgSrc,
      "data-visible": ""
    }
  })], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 386 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "logo-marque",
    attrs: {
      "data-name": "Logo Marque",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 15.59 19.76"
    }
  }, [_c('path', {
    staticStyle: {
      "fill": "none"
    },
    attrs: {
      "d": "M7.8.5a7.37,7.37,0,0,1,7.3,7.43V19.26H.5V7.93A7.37,7.37,0,0,1,7.8.5"
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 387 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "container",
    staticClass: "slideshow"
  }, [_vm._l((_vm.slides), function(slide, index) {
    return _c('img', {
      attrs: {
        "data-visible": index === _vm.current,
        "src": _vm.shopifyImg(slide.src)
      }
    })
  }), _vm._v(" "), _c('button', {
    attrs: {
      "title": "Previous"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.slide('previous')
      }
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "title": "Next"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.slide('next')
      }
    }
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 388 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.site) ? _c('div', {
    staticClass: "app-footer"
  }, [_c('div', {
    staticClass: "app-footer__subscribe is-hidden-tablet"
  }, [_c('subscribe-form')], 1), _vm._v(" "), _c('footer', {
    staticClass: "nimbus-sans underline-links"
  }, [_c('links', {
    staticClass: "is-hidden-mobile",
    attrs: {
      "links": this.site.data['site.footer_links_1'].value
    }
  }), _vm._v(" "), _c('links', {
    staticClass: "right is-hidden-mobile",
    attrs: {
      "links": this.site.data['site.footer_links_2'].value
    }
  }), _vm._v(" "), _c('links', {
    staticClass: "h8 is-hidden-tablet",
    attrs: {
      "links": this.site.data['site.footer_mobile_links_1'].value
    }
  })], 1)]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 389 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "landscape-image"
  }, [_c('collection-image', {
    attrs: {
      "image": _vm.image
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 390 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "purchase"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/collections/bespoke-service"
    }
  }, [_c('div', {
    staticClass: "bannerspacer"
  }), _vm._v(" "), _c('div', {
    staticClass: "banner"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h2', [_vm._v("\n          Dovedale Design"), _c('Br'), _vm._v("\n          Studio’S"), _c('Br'), _vm._v("\n          Bespoke Service\n        ")], 1), _vm._v(" "), _c('div', {
    staticClass: "logo"
  }, [_c('LogoMarque')], 1)])])]), _vm._v(" "), _vm._l((_vm.slugs), function(slug) {
    return [_c('collection-items', {
      attrs: {
        "slug": slug,
        "collections": _vm.collections,
        "options": {
          customOrders: false,
          isPurchase: true
        }
      }
    })]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 391 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "h8"
  }, [_vm._t("default"), _vm._v(" "), _vm._l((_vm.links), function(item) {
    return (item.link && item.label) ? _c('li', [(item.link.type === 'Link.document') ? [_c('router-link', {
      attrs: {
        "to": _vm.internalRt(item.link.type, item.link.value.document.uid)
      }
    }, [_vm._v(_vm._s(item.label.value[0].text))])] : (item.link.type === 'Link.web') ? [_c('a', {
      attrs: {
        "href": item.link.value.url,
        "target": item.link.value.target,
        "rel": "noopener"
      }
    }, [_vm._v(_vm._s(item.label.value[0].text))])] : _vm._e()], 2) : _vm._e()
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 392 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('transition', {
    attrs: {
      "name": "fadeinplace"
    }
  }, [(_vm.page) ? _c('page-body', {
    attrs: {
      "title": _vm.text(_vm.page, 'page.title'),
      "body": _vm.html(_vm.page, 'page.body'),
      "footHead": _vm.slug === 'contact' ? false : 'Contact',
      "footBody": _vm.html(_vm.site, 'site.contact_details'),
      "showCredits": _vm.slug === 'info',
      "fontStyle": _vm.fontStyle
    }
  }, [(_vm.showEnquireBtn) ? _c('div', [_c('a', {
    attrs: {
      "href": ("mailto:" + _vm.email),
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('enquire-btn', [_vm._v("Enquries")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.showNewsletterForm) ? _c('subscribe-form', {
    staticClass: "is-hidden-mobile",
    attrs: {
      "mailchimpNewsletterID": _vm.mailchimpNewsletterID
    }
  }) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), (_vm.pageNotFound) ? _c('article', [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('appfooter', {
    attrs: {
      "site": _vm.site
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h1', [_vm._v("Page Not Found")])])
}]}

/***/ }),
/* 393 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "collections-index"
  }, [_c('section', _vm._l((_vm.collectionsSorted), function(item) {
    return (!_vm.isHidden(item)) ? _c('router-link', {
      key: item.id,
      attrs: {
        "to": '/collections/' + item.uid
      }
    }, [_c('article', [_c('header', {
      staticClass: "sticky-header uppercase"
    }, [_c('h2', {
      staticClass: "h4"
    }, [(!_vm.isBespoke(item)) ? [_vm._v("\n              Collection\n            ")] : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (item.getText('collection.number')) ? [_vm._v("\n              Nr. "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(item.getText('collection.number'))
      }
    }), _vm._v(" "), _c('br')] : _vm._e(), _vm._v(" "), (_vm.isBespoke(item)) ? [_vm._v("\n              Dovedale Design"), _c('br'), _vm._v("Studio’s"), _c('br')] : _vm._e(), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(item.getText('collection.title'))
      }
    })], 2), _vm._v(" "), _c('nav', {
      staticClass: "h8 is-hidden-mobile"
    }, [(_vm.isBespoke(item)) ? [_c('a', [_vm._v("View Gallery")]), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": '/collections/' + item.uid + '/items'
      }
    }, [_vm._v("Enquire")])] : [_c('a', [_vm._v("View Collection")]), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": '/collections/' + item.uid + '/items'
      }
    }, [_vm._v("Purchase Collection")])]], 2)]), _vm._v(" "), _c('section', _vm._l((item.getGroup('collection.index-images').toArray()), function(photo) {
      return _c('div', {
        style: ({
          backgroundImage: 'url(' + _vm.respImgUrl(photo) + ')'
        })
      })
    }), 0)])]) : _vm._e()
  }), 1), _vm._v(" "), _c('appfooter', {
    attrs: {
      "site": _vm.site
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 394 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.collection) ? _c('article', {
    staticClass: "collection",
    class: _vm.collection.slug
  }, [_c('header', [_c('h1', {
    staticClass: "h2 type-scales--large"
  }, [(_vm.number) ? [_vm._v("\n        Collection\n        "), _c('br')] : _vm._e(), _vm._v(" "), (_vm.number) ? [_vm._v("\n        Nr. " + _vm._s(_vm.number) + "\n        "), _c('br')] : _vm._e(), _vm._v(" "), (_vm.isBespoke) ? [_vm._v("\n        Dovedale Design"), _c('br'), _vm._v("Studio’s"), _c('br')] : _vm._e(), _vm._v("\n      " + _vm._s(_vm.title) + "\n      "), (_vm.isBespoke) ? [_c('div', {
    staticClass: "logo"
  }, [_c('LogoMarque')], 1)] : _vm._e()], 2)]), _vm._v(" "), (_vm.loadStory) ? _c('story', {
    attrs: {
      "sections": _vm.collection.getGroup('collection.sections').value,
      "mobile": _vm.mobile,
      "window": _vm.window
    }
  }) : _vm._e(), _vm._v(" "), _c('items', {
    attrs: {
      "collections": _vm.collections,
      "slug": _vm.slug,
      "itemViewName": 'Collection - Item Overlay'
    }
  }), _vm._v(" "), _c('nav', {
    staticClass: "outlined is-hidden-mobile"
  }, [(_vm.prevCollection) ? _c('router-link', {
    staticClass: "previous",
    attrs: {
      "to": {
        name: 'Collection',
        params: {
          slug: _vm.prevCollection.uid
        }
      }
    }
  }, [_c('span', [_vm._v("Previous")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "underline-links"
  }, [_c('span', {
    staticClass: "h7 nimbus-sans"
  }, [_vm._v("Share via "), _vm._l((_vm.shareBtns), function(button) {
    return [_c('a', {
      attrs: {
        "href": button.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(button.label))]), _vm._v(" ")]
  })], 2)]), _vm._v(" "), (_vm.nextCollection) ? _c('router-link', {
    staticClass: "next",
    attrs: {
      "to": {
        name: 'Collection',
        params: {
          slug: _vm.nextCollection.uid
        }
      }
    }
  }, [_c('span', [_vm._v("Next")])]) : _vm._e()], 1), _vm._v(" "), _c('nav', {
    staticClass: "is-hidden-tablet uppercase"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Collections'
      }
    }
  }, [_vm._v("Back to Collections")])], 1), _vm._v(" "), (_vm.site) ? _c('footer', {
    staticClass: "is-hidden-mobile"
  }, [_c('div', [_c('subscribe-form', {
    attrs: {
      "mailchimpNewsletterID": _vm.site.getText('site.mailchimp-newsletter-id')
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('appfooter', {
    attrs: {
      "site": _vm.site
    }
  })], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 395 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cover-photo"
  }, [(_vm.imageUrl) ? _c('figure', [_c('img', {
    attrs: {
      "src": _vm.imageUrl,
      "alt": _vm.imageAlt
    }
  }), _vm._v(" "), _c('figcaption', {
    staticClass: "h9 nimbus-sans",
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  })]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 396 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    staticClass: "collection-image"
  }, [(_vm.image.type === 'image-360') ? _c('interactive-image', {
    attrs: {
      "id": _vm.image.src,
      "alt": _vm.image.alt
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.image.src,
      "alt": _vm.image.alt
    }
  }), _vm._v(" "), (_vm.hasTable) ? _c('div', {
    staticClass: "table vcenter-content h7 century-mono"
  }, [_c('div', {
    staticClass: "inner vcenter"
  }, [_c('h4', [_vm._v(_vm._s(_vm.image.table.header))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.image.table.text)
    }
  })])]) : _vm._e(), _vm._v(" "), _c('figcaption', {
    domProps: {
      "innerHTML": _vm._s(_vm.setCaption(_vm.image))
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 397 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.collection) ? _c('section', {
    staticClass: "collection--items",
    attrs: {
      "id": "items"
    }
  }, [_c('header', [_c('h2', {
    staticClass: "h5"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (!_vm.options.isPurchase || _vm.readMore == true) ? [_c('div', {
    staticClass: "textbody",
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }), _vm._v(" "), (_vm.readMore) ? _c('div', {
    staticClass: "spacer"
  }) : _vm._e()] : (_vm.text) ? [_c('button', {
    on: {
      "click": function($event) {
        _vm.readMore = !_vm.readMore
      }
    }
  }, [_c('span', {
    staticClass: "h6 readmore"
  }, [_vm._v("Read Description")])])] : _vm._e()], 2), _vm._v(" "), _c('ul', _vm._l((_vm.products), function(product) {
    return _c('li', [_c('sku-item', {
      attrs: {
        "product": product,
        "viewName": _vm.itemViewName,
        "isPurchase": _vm.options.isPurchase,
        "collectionSlug": _vm.slug
      }
    })], 1)
  }), 0), _vm._v(" "), _c('footer', [(_vm.cart !== null && this.cart.lineItemCount > 0) ? [_c('a', {
    staticClass: "enquire-btn century-mono",
    attrs: {
      "id": "placeOrderBtn",
      "href": this.cart.checkoutUrl
    }
  }, [_c('span', {
    staticClass: "h5"
  }, [_vm._v("CHECKOUT")])])] : [(_vm.options.customOrders) ? [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.products.length > 0),
      expression: "products.length > 0"
    }],
    staticClass: "enquire-btn century-mono",
    attrs: {
      "id": "enquireBtn",
      "href": 'mailto:' + _vm.email,
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "h5 label"
  }, [_vm._v("CUSTOM ORDERS")]), _vm._v(" "), _vm._m(0)])] : _vm._e()]], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view', {
    attrs: {
      "products": _vm.products,
      "collectionTitle": _vm.shortTitle
    }
  })], 1), _vm._v(" "), (_vm.slug === 'bespoke-service' && _vm.collections.length && _vm.collections[0].data['collection.items--enquire-email']) ? _c('div', [_c('a', {
    staticClass: "enquire-btn",
    attrs: {
      "href": 'mailto:' + _vm.collections[0].data['collection.items--enquire-email'].value[0].text
    }
  }, [_vm._v("Enquire")]), _vm._v(" "), _c('br')]) : _vm._e()], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "h8"
  }, [_vm._v("For purchasing options"), _c('br'), _vm._v(" and bespoke enquiries please"), _c('br'), _vm._v(" contact us here.")])
}]}

/***/ }),
/* 398 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "credits h7 nimbus-sans underline-links"
  }, [_c('h6', {
    staticClass: "no-case"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.creditsVisible = !_vm.creditsVisible
      }
    }
  }, [_vm._v("Credits")])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.creditsVisible),
      expression: "creditsVisible"
    }]
  }, [_vm._v("\n    Design & Art Direction by "), _c('a', {
    attrs: {
      "href": "http://spencerfenton.co.uk/",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("Spencer Fenton")]), _c('br'), _vm._v("\n    Photography by Chloe Tun Tun"), _c('br'), _vm._v("\n    Programming by "), _c('a', {
    attrs: {
      "href": "http://everettwilliams.info",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("Everett Williams")]), _c('br'), _vm._v("\n    VR images by "), _c('a', {
    attrs: {
      "href": "http://www.universalassemblyunit.com",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("Universal Assembly Unit")])])])
},staticRenderFns: []}

/***/ }),
/* 399 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['collection-diptych', {
      'collection-diptych--white': _vm.variant === 'white'
    }]
  }, _vm._l((_vm.images), function(image, index) {
    return (index < 2) ? _c('div', {
      staticClass: "panel"
    }, [_c('collection-image', {
      attrs: {
        "image": _vm.buildImgObj(image),
        "grayscale": true
      }
    })], 1) : _vm._e()
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 400 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subscribe-form textbody"
  }, [_c('h4', [_vm._v("Receive news of future releases")]), _vm._v(" "), _c('p', [_vm._v("Dovedale will be regularly realising new collections. We would like to keep you updated and informed. Please subscribe or contact us for custom orders.")]), _vm._v(" "), _c('form', {
    staticClass: "h8 nimbus-sans",
    attrs: {
      "id": "subscribeForm",
      "action": '//dovedaledesignstudio.us15.list-manage.com/subscribe/post?u=f5497669bd87e7e8a503aeb85&id=' + _vm.mailchimpNewsletterID,
      "method": "post",
      "name": "mc-embedded-subscribe-form",
      "target": "_blank"
    },
    on: {
      "submit": _vm.submit
    }
  }, [_c('input', {
    attrs: {
      "type": "email",
      "value": "",
      "placeholder": "Your Email",
      "name": "EMAIL",
      "id": "mce-EMAIL",
      "required": ""
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('input', {
    attrs: {
      "type": "submit",
      "value": "Sign Up",
      "name": "subscribe",
      "id": "mc-embedded-subscribe"
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "absolute",
      "left": "-5000px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('input', {
    attrs: {
      "type": "text",
      "name": "b_f5497669bd87e7e8a503aeb85_a60f52dceb",
      "tabindex": "-1",
      "value": ""
    }
  })])
}]}

/***/ }),
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 406 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[126]);


// WEBPACK FOOTER //
// static/js/app.02e87b54434fb28b929a.js